import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

import { CalendarIcon, DateInputStyled } from './DateInput.styled';
import { TextInputStyled } from '../TextInput/TextInput.styled';

import { DEFAULT_DATE_FORMAT } from './DateInput.constants';
import { Props } from './DateInput.types';
import { getInputStates } from '../../utils';

export const DateInput = ({
  id,
  labelId,
  value,
  status = 'default',
  placeholder,
  required = false,
  autoComplete,
  dateFormat = DEFAULT_DATE_FORMAT,
  blockFutureDays,
  onChange,
  onBlur,
  onKeyDown,
  onFocus
}: Props) => {
  const selectedDate = value ? new Date(value) : null;
  const isFilled = Boolean(value);
  const { isDisabled, isReadOnly, isValid } = getInputStates(status);
  const today = new Date();

  return (
    <DateInputStyled $status={status} $isFilled={isFilled}>
      <DatePicker
        id={id}
        className="v2"
        showIcon
        customInput={<TextInputStyled $status={status} $isFilled={isFilled} />}
        disabled={isDisabled}
        selected={selectedDate}
        readOnly={isReadOnly}
        ariaInvalid={isValid ? 'false' : 'true'}
        ariaLabelledBy={labelId}
        ariaRequired={`${required}`}
        placeholderText={placeholder}
        autoComplete={autoComplete}
        dateFormat={dateFormat}
        onBlur={onBlur}
        onChange={(value: Date | null) => onChange?.(value)}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        popperPlacement="bottom"
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        yearDropdownItemNumber={60}
        scrollableYearDropdown
        icon={<CalendarIcon />}
        maxDate={blockFutureDays ? today : undefined}
      />
    </DateInputStyled>
  );
};
